// Záměrně uvedeno v češtině, aby se zabránilo nedorozumění u nepřeložitelné právní terminologie.
export enum CzechDocumentType {
  Smlouva = "Smlouva",
  PotvrzeniOStudiu = "PotvrzeniOStudiu",
  DokladODosazeniZakladnihoVzdelani = 'DokladODosazeniZakladnihoVzdelani',
  ProhlaseniPoplatnika = "ProhlaseniPoplatnika",
  PotvrzeniOEvidenciNaUraduPrace = "PotvrzeniOEvidenciNaUraduPrace",
  PotvrzeniOPeciODite = "PotvrzeniOPeciODite",
  PotvrzeniJinehoZamestnavateleOOdvoduZdravotnihoPojisteni = "PotvrzeniJinehoZamestnavateleOOdvoduZdravotnihoPojisteni",
  VymerMaterskeRodicovskeDovolene = "VymerMaterskeRodicovskeDovolene",
  VymerStarobnihoDuchodu = "VymerStarobnihoDuchodu",
  VymerInvalidnihoDuchodu12Stupne = "VymerInvalidnihoDuchodu12Stupne",
  VymerInvalidnihoDuchodu1Stupne = "VymerInvalidnihoDuchodu1Stupne",
  VymerInvalidnihoDuchodu2Stupne = "VymerInvalidnihoDuchodu2Stupne",
  VymerInvalidnihoDuchodu3Stupne = "VymerInvalidnihoDuchodu3Stupne",
  PrukazZTPP = "PrukazZTPP",
  VstupniLekarskaProhlidka = "VstupniLekarskaProhlidka",
}
